import DIApi from './_diApi';

class AccountingObjectInfoAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'accountingObjectInfos';
}

export default new AccountingObjectInfoAPI();
